import { kebabCase } from 'lodash';
import { transformCountryDto } from 'data/transformers/country';
import { transformClosetPromoPerformanceDto } from 'data/transformers/closet-promo-performance';
import { transformBrandDto } from 'data/transformers/brand';
import { transformClosetPromotionPricing } from 'data/transformers/closet-promotion';
import { transformFavouritesItemsGroupDto } from 'data/transformers/favourites-items-group';
import { transformFeedItemDtoToProductItem, transformFavouriteItemDtoToProductItem, transformItemDtosToProductItems, transformCollectionItemDtosToProductItems } from 'data/transformers/product-item';
import { transformAdsPlacements } from 'data/transformers/ads';
import { transformPhotoTipDto, transformPhotoTipDtos } from 'data/transformers/photo-tip';
import { transformItemConfigurationDto, transformItemDto } from 'data/transformers/item';
import { transformItemShippingDetailsDto } from 'data/transformers/shipping-option';
import { transformFeedbackFormDto } from 'data/transformers/feedback-form';
import { transformShippingDateDto } from 'data/transformers/shipping-date';
import { transformNotificationSettingsDto } from 'data/transformers/notification-settings';
import { transformFeaturedCollectionPricing } from 'data/transformers/featured-collection-pricing';
import { transformFeaturedCollectionOrder } from 'data/transformers/featured-collection-order';
import { transformUserDto, transformUserDtos } from 'data/transformers/user';
import { transformPaginationDto } from 'data/transformers/pagination';
import { transformTermsAndConditionsDto } from 'data/transformers/terms-and-conditions';
import { transformInfoBoardPostDto, transformInfoBoardPostDtos, transformProfileUserInfoDto, transformSellerOfferOptionsDto } from 'data/transformers';
import { transformMyOrderDto } from 'data/transformers/my-order';
import { transformFollowingUsersDtos } from 'data/transformers/following-user';
import { AccessChannel } from 'constants/index';
import { transformTermsAndConditionsContentDto } from 'data/transformers/terms-and-conditions-content';
import { transformBusinessAccountsTermsOfUseDto } from 'data/transformers/business-account';
import { transformReferralInviteInstructionsDto, transformReferralShareDto } from 'data/transformers/referral';
import { transformInSiteSeoContentDto } from 'data/transformers/seo';
import { transformCollectionsPlansPricing } from 'data/transformers/collections-plan-pricing';
import { transformCollectionPolicy } from 'data/transformers/collection-policy';
import { transformCollections } from 'data/transformers/collections';
import { transformCollection } from 'data/transformers/collection';
export const transformCountryResponse = response => response.countries.map(transformCountryDto);
export const transformClosetPromoPerformanceResponse = response => response.closet_promotion_performance && transformClosetPromoPerformanceDto(response.closet_promotion_performance);
export const transformBrandsResponse = response => response.brands.map(transformBrandDto);
export const transformFeedbackRatingsResponse = response => {
  if (!response.feedback_ratings) return undefined;
  return transformFeedbackFormDto(response.feedback_ratings);
};
export const transformClosetPromotionPricingResponse = response => transformClosetPromotionPricing(response.promoted_closet_pricing);
export const transformFavouritesItemsGroupsResponse = response => response.groups.map(transformFavouritesItemsGroupDto);
export const transformUserFavouritesItemsGroupResponse = response => ({
  name: response.name,
  items: response.items.map(transformFavouriteItemDtoToProductItem)
});
export const transformUserFavouritesItemsGroupAllResponse = response => ({
  count: response.count,
  itemsPreview: response.items_preview.map(transformFavouriteItemDtoToProductItem)
});
export const transformGetUngroupedUserFavouriteItemsResponse = response => response.items.map(transformFeedItemDtoToProductItem);
export const transformGetAdsPlacements = response => transformAdsPlacements(response.placements);
export const transformPhotoTipsResponse = response => transformPhotoTipDtos(response.photo_tips);
export const transformPhotoTipResponse = response => transformPhotoTipDto(response.photo_tip);
export const transformGetShippingDetails = response => response.shipping_details && transformItemShippingDetailsDto(response.shipping_details);
export const transformUserSizesResponse = response => ({
  sizeIds: response.size_ids
});
export const transformGetShipingDatesResponse = response => response.options.map(transformShippingDateDto);
export const transformSizeGroupsResponse = response => ({
  sizeGroups: response.size_groups
});
export const transformNotificationSettingsResponse = response => transformNotificationSettingsDto(response.notification_settings.email);
export const transformFaqEntryResponse = _ref => {
  let {
    faq_entry
  } = _ref;
  if (!faq_entry) return undefined;
  return {
    id: faq_entry.id,
    title: faq_entry.title,
    body: faq_entry.body
  };
};
export const transformFaqEntrySearchResponse = _ref2 => {
  let {
    faq_entries
  } = _ref2;
  if (!faq_entries.length) return null;
  return faq_entries.map(_ref3 => {
    let {
      id,
      title
    } = _ref3;
    return {
      id,
      title,
      path: "/help/".concat(kebabCase("".concat(id, "-").concat(title)), "?access_channel=").concat(AccessChannel.HcSearch)
    };
  });
};
export const transformGetItemConfigurationResponse = response => transformItemConfigurationDto(response.item_configuration);
export const transformFeaturedCollectionPricingResponse = response => transformFeaturedCollectionPricing(response.featured_collection_pricing);
export const transformFeaturedCollectionOrderResponse = response => transformFeaturedCollectionOrder(response.featured_collection_order);
export const transformFollowingUsersResponse = response => ({
  users: transformFollowingUsersDtos(response.users),
  pagination: transformPaginationDto(response.pagination)
});
export const transformUsersResponse = response => ({
  users: transformUserDtos(response.users),
  pagination: transformPaginationDto(response.pagination)
});
export const transformWalletIncomeSettingsResponse = _ref4 => {
  let {
    is_monthly_report_enabled
  } = _ref4;
  return {
    isMonthlyReportEnabled: is_monthly_report_enabled
  };
};
export const transformInvoicesAvailableDatesResponse = _ref5 => {
  let {
    available_dates
  } = _ref5;
  return {
    availableDates: [...available_dates]
  };
};
export const transformUserResponse = response => ({
  user: transformUserDto(response.user)
});
export const transformHomepageBlockResponse = response => {
  var _response$promo_box;

  return {
    homepageSessionId: response.homepage_session_id,
    catalogs: response.catalogs,
    promoBox: (_response$promo_box = response.promo_box) === null || _response$promo_box === void 0 ? void 0 : _response$promo_box.entity,
    blocks: response.blocks
  };
};
export const transformFeedEventsResponse = response => ({
  events: response.feed_events,
  initialMaxScore: response.max_score,
  showLoadMoreButton: response.show_load_more_button,
  totalItemCount: response.total_item_count
});
export const transformEmailVerificationCodeResponse = response => {
  var _response$can_change_;

  return {
    email: response.email,
    canChangeEmail: (_response$can_change_ = response.can_change_email) !== null && _response$can_change_ !== void 0 ? _response$can_change_ : true
  };
};
export const transformInfoBoardPostsResponse = response => transformInfoBoardPostDtos(response.info_posts);
export const transformTermsAndConditionsResponse = response => transformTermsAndConditionsDto(response.terms_and_conditions);
export const transformInfoBoardPostResponse = response => transformInfoBoardPostDto(response.info_post);
export const transformNotificationLandingsResponse = _ref6 => {
  let {
    notification_landing
  } = _ref6;
  return {
    body: notification_landing.body,
    buttonTitle: notification_landing.button_title,
    buttonUrl: notification_landing.button_url,
    code: notification_landing.code,
    id: notification_landing.id,
    imageUrl: notification_landing.image_url,
    title: notification_landing.title
  };
};
export const transformMyOrdersResponse = response => ({
  orders: response.my_orders.map(transformMyOrderDto),
  pagination: transformPaginationDto(response.pagination)
});
export const transformTermsAndConditionsContentResponse = response => transformTermsAndConditionsContentDto(response);
export const transformFaqEntryRecommendedFaqsResponse = _ref7 => {
  let {
    faq_recommendations
  } = _ref7;
  if (!faq_recommendations.length) return null;
  return faq_recommendations;
};
export const transformFaqEntryRelatedFaqsResponse = _ref8 => {
  let {
    related_faqs
  } = _ref8;
  if (!related_faqs.length) return null;
  return related_faqs;
};
export const transformBusinessAccountsTermsOfUse = response => ({
  orders: response.my_orders.map(transformMyOrderDto),
  pagination: transformPaginationDto(response.pagination)
});
export const transformBusinessAccountsTermsOfUseResponse = response => transformBusinessAccountsTermsOfUseDto(response);
export const transformReferralShareResponse = _ref9 => {
  let {
    share
  } = _ref9;
  return transformReferralShareDto(share);
};
export const transformUserItemsResponse = response => transformItemDtosToProductItems(response.items);
export const transformReferralInviteInstructionsResponse = _ref10 => {
  let {
    invite_instructions
  } = _ref10;
  return transformReferralInviteInstructionsDto(invite_instructions);
};
export const transformProfileUserInfoResponse = response => transformProfileUserInfoDto(response);
export const transformInSiteSeoContentResponse = _ref11 => {
  let {
    data
  } = _ref11;
  return transformInSiteSeoContentDto(data.attributes);
};
export const transformCollectionsPlansPricingResponse = response => transformCollectionsPlansPricing(response.collection_pricing);
export const transformAvailableUserItemsForCollectionResponse = response => ({
  items: transformCollectionItemDtosToProductItems(response.items),
  pagination: transformPaginationDto(response.pagination)
});
export const transformCollectionPolicyResponse = response => transformCollectionPolicy(response.policy);
export const transformCollectionsResponse = response => transformCollections(response);
export const transformCollectionResponse = response => transformCollection(response.featured_collection);
export const transformItemResponse = response => transformItemDto(response.item);
export const transformCreateReferrerResponse = response => ({
  referralInviteUrl: response.referral_invite_url,
  referrerId: response.referrer_id
});
export const transformSellerOfferOptionsResponse = response => transformSellerOfferOptionsDto(response.seller_offer_options);